import { render, staticRenderFns } from "./mb-textarea.vue?vue&type=template&id=23dd3750&"
import script from "./mb-textarea.vue?vue&type=script&lang=ts&"
export * from "./mb-textarea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports